module.exports = __webpack_public_path__ + "static/media/grease-2.32dca362.png";